<template>
    <div class="dataBtnList">
        <div class="dataBtn" v-for="(item, index) of records" :key='index' :class="[index < records.length-1 ? 'right-line' : '']" @click="jumpToBookPage(item)">
            <i class="iconfont icon" :class="[item.icon]"></i>
            <div class="title">{{item.title}}</div>
            <div class="count">{{item.count}}条</div>
        </div>
    </div>
</template>

<script>
import statisticsApi from '@/api/statistics'

export default {
    data () {
        return {
            records: []
        }
    },
    mounted () {
        // for (let i = 0; i < 12; i++) {
        //     this.records.push({
        //         title: '文献',
        //         count: '200'
        //     });
        // }
        this.getData();
    },
    methods: {
        getData () {
            let that = this;
            that.records = [];

            statisticsApi.getSubItemStatistics({
                type: 'all',
                libraryCode: this.global.getLibraryInfos().code
            }).then(response => {
                // console.log(response);
                if (response.code === 200) {
                    // that.records = response.data;
                    for (let key in response.data) {
                        that.records.push({
                            title: key,
                            count: response.data[key],
                            icon: that.getDataIcon(key)
                        });
                    }
                }
            })
        },
        getDataIcon (name) {
            let records = {
                '专题': 'icon-icon_xinyong_xianxing_jijin-',
                '事件': 'icon-shijianchuli',
                '人物': 'icon-renwu-tuandui',
                '作品': 'icon-zuopin',
                '全部数据': 'icon-quanbu',
                '图表元数据': 'icon-tupian',
                '地理': 'icon-earth-full',
                '文献元数据': 'icon-yuanshuju-liebiaoshitu',
                '机构': 'icon-zuzhijigou',
                '细颗粒度数据': 'icon-yuanshuju'
            };
            return records[name];
        },
        jumpToBookPage (item) {
            console.log(item)
            this.$router.push({
                name: 'book',
				query: {
					schemaTitle: item.title
				}
            })
        }
    }
};
</script>

<style lang='less' scoped>
@import "~@/styles/variables.less";
.dataBtnList {
    width: 1200 * @uw;
    height: 149 * @uh;
    display: flex;
    // justify-content: space-between;
    align-items: center;
    margin-left: 360 * @uw;
    position: relative;
    margin-top: 100 * @uh;
    background: rgb(252, 252, 252);
    box-shadow: 0px 0px 10px 5px #e0e0e0;
    // box-shadow: 0 0 1px hsl(0deg 0% 86% / 5%);
    border-radius: 10 * @uw;

    .dataBtn {
        width: 131 * @uw;
        height: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        color: #6d6d6d;
        font-size: 16 * @uw;
        cursor: pointer;

        .icon {
            margin-top: 20 * @uh;
            color: rgb(141,94,26);
        }

        .title {
            margin-top: 10 * @uh;
            width: 100%;
            overflow: hidden;
            display: flex;
            align-items: center;
            justify-content: center;
            text-overflow:ellipsis;
            white-space: nowrap;
        }
        .count {
            color: black;
            margin-top: 10 * @uh;
        }
    }
    .right-line {
        border-right: 1px solid rgb(235, 232, 232);
    }
}
</style>
